import React from 'react'
import styled from 'styled-components'
import {connect} from 'react-redux'
import EditButton from './EditButton'

const ButtonComponent = styled.div`
    border-top: 1px solid rgba(0, 0, 0, 0.14);
    position: relative;
    display: inline-flex;
    padding: 10px 10px 10px 0;
    cursor: pointer;
    user-select: none;

    button {
        display: none;
    }

    :hover {
        button {
            display: inline-flex;
        }
    }
`

class SignatureControl extends React.Component {
    onEdit = () => {
        this.props.onEdit(this.props.type, this.props.id, this.props.data)
    }

    render() {
        const signatures = this.props.signatures ? this.props.signatures[this.props.application] : null
        const option = signatures && signatures.find(item => item.id === Number(this.props.data.value))

        return (
            <React.Fragment>
                {option &&
                    <ButtonComponent>
                        <span dangerouslySetInnerHTML={{ __html: option.html }} />
                        <EditButton onClick={this.onEdit} />
                    </ButtonComponent>
                }
            </React.Fragment>
        )
    }
}

const mapStateToProps = ({email, applications}) => ({
    signatures: email.signatures,
    application: applications.current
})

export default connect(mapStateToProps)(SignatureControl)
